import {DatabasePage as DocumentsAndReferencesPage} from 'modules/InspectedList';

export default DocumentsAndReferencesPage;
